<template>
  <main class="unified__menu__container position-relative">
    <b-avatar
      @click.native="menuVisible = !menuVisible"
      src="@/assets/images/icons/unified-menu/unified-menu.svg"
      size="4em"
      class="cursor-pointer icon"
      variant="light"
    ></b-avatar>

    <b-collapse
      ref="unified_collapse"
      class="position-absolute apps__container"
      v-model="menuVisible"
      @shown="onShown"
    >
      <div class="d-flex">
        <div class="text text-center py-75 w-100">Apps</div>
        <div class="triangle position-absolute"></div>
      </div>
      <div
        class="apps"
        @mouseleave="
          selectedAppId = '';
          appMenuVisible = false;
        "
      >
        <div
          class="d-flex align-items-center w-100 flex-wrap px-50"
          v-if="
            userAppSubscriptions && Object.keys(userAppSubscriptions).length > 0
          "
        >
          <div v-for="(appId, i) in Object.keys(userAppSubscriptions)" :key="i">
            <a
              v-if="
                (userAppSubscriptions[appId].length === 1 ||
                  appId === 'getboarded') &&
                getAppDataById(appId) !== -1
              "
              @click="menuVisible = !menuVisible"
              target="_blank"
              :href="userAppSubscriptions[appId][0].loginLink"
              class="d-flex align-items-center justify-content-center my-50"
            >
              <small
                class="d-flex flex-column align-items-center justify-content-center app"
              >
                <b-avatar
                  class="app__icon p-25 mx-75 cursor-pointer"
                  v-b-tooltip.hover.bottom="
                    appId === 'getboarded'
                      ? 'Getboarded Technologies'
                      : userAppSubscriptions[appId][0].organizationName
                  "
                  :src="getAppDataById(appId).icon"
                  :style="{ background: getAppDataById(appId).color }"
                  size="4.25em"
                ></b-avatar>
                <div class="mt-25 app__text">
                  {{ getAppDataById(appId).shortTitle }}
                </div>
              </small>
            </a>

            <div
              :class="selectedAppId === appId ? 'position-relative' : ''"
              v-else-if="getAppDataById(appId) !== -1 && appId !== 'getboarded'"
            >
              <small
                class="d-flex flex-column align-items-center justify-content-center app my-50 cursor-pointer"
                @mouseenter="
                  selectedAppId = appId;
                  appMenuVisible = true;
                "
                @mouseleave="
                  selectedAppId = '';
                  appMenuVisible = false;
                "
              >
                <b-avatar
                  class="app__icon p-25 mx-75 cursor-pointer"
                  :src="getAppDataById(appId).icon"
                  :style="{ background: getAppDataById(appId).color }"
                  size="4.25em"
                ></b-avatar>
                <div class="mt-25 app__text">
                  {{ getAppDataById(appId).shortTitle }}
                </div>
              </small>

              <b-collapse
                v-if="appId === selectedAppId"
                class="position-absolute apps__container apps__container--single"
                v-model="appMenuVisible"
                @mouseenter.native="
                  selectedAppId = appId;
                  appMenuVisible = true;
                "
                @mouseleave.native="
                  selectedAppId = '';
                  appMenuVisible = false;
                "
              >
                <div class="d-flex flex-wrap">
                  <a
                    v-for="(app, index) in userAppSubscriptions[selectedAppId]"
                    :key="index"
                    @click="menuVisible = !menuVisible"
                    target="_blank"
                    :href="app.loginLink"
                    class="d-flex align-items-center justify-content-center my-75"
                  >
                    <small
                      class="d-flex flex-column align-items-center justify-content-center app"
                    >
                      <b-avatar
                        class="app__icon p-25 mx-75 cursor-pointer"
                        v-b-tooltip.hover.bottom="app.organizationName"
                        :src="getAppDataById(selectedAppId).icon"
                        :style="{
                          background: app.organizationColor,
                        }"
                        size="4.25em"
                      ></b-avatar>

                      <!-- <div class="mt-25 app__text">
                        {{ getAppDataById(selectedAppId).shortTitle }}
                      </div> -->
                    </small>
                  </a>

                  <div
                    class="triangle triangle--2 position-absolute"
                  ></div></div
              ></b-collapse>
            </div>
          </div>
        </div>

        <div v-else class="py-75 px-1 apps__does-not-exist">
          No App Subscriptions Found.
        </div>
      </div>
    </b-collapse>
  </main>
</template>

<script>
import { BAvatar, BCollapse, VBTooltip } from "bootstrap-vue";
import apps from "@/assets/data/marketplace-list.js";
export default {
  name: "UnifiedMenu",
  data() {
    return {
      apps,
      menuVisible: false,
      appMenuVisible: false,
      selectedAppId: "",
    };
  },
  components: {
    BAvatar,
    BCollapse,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  computed: {
    userData() {
      return this.$store.state.user.userData;
    },
    userAppSubscriptions() {
      return this.$store.state.user.appSubscriptions;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
  created() {
    this.appSubscription();
  },
  methods: {
    onShown() {
      document.body.addEventListener("click", this.onClickOutside);
    },
    onClickOutside(event) {
      // Check if click event target is outside of the b-collapse element
      if (!this.$refs.unified_collapse.$el.contains(event.target)) {
        this.menuVisible = false;
        document.body.removeEventListener("click", this.onClickOutside);
      }
    },
    appSubscription() {
      if (this.isUserLoggedIn) {
        this.$store
          .dispatch("user/fetchUserAppSubscriptions", this.userData._id)
          .then(() => {})
          .catch(() => {});
      }
    },
    getAppDataById(id) {
      const appIndex = this.apps.findIndex((app) => {
        return app.id === id;
      });

      if (appIndex !== -1) return this.apps[appIndex];
      else return appIndex;
    },
  },
  beforeDestroy() {
    // Remove click event from body when component is destroyed
    document.body.removeEventListener("click", this.onClickOutside);
  },
};
</script>

<style lang="scss" scoped>
$main-color: #e82b51;
$bgColor: #f2c244;

.unified__menu__container {
  .icon {
    background: transparent;
  }
  .apps__container {
    background: #f9f9f9;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    max-width: 22.5em;
    z-index: 1000;
    width: max-content;
    right: 50%;
    transform: translate(12.5%, 0);
    border-radius: 8px;
    margin-top: 15px;
    &--single {
      margin-top: 0px;
      max-width: 21em;
      background: #eae9e9;
    }
    .triangle {
      right: 1em;
      top: -1em;
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 25px solid $bgColor;
      &--2 {
        border-bottom: 25px solid #eae9e9;
      }
    }

    small {
      z-index: +1;
    }

    .text {
      background: $bgColor;
      border-radius: 8px 8px 0 0;
      font-size: 1.25em;
      color: #ffffff;
    }

    .apps {
      .app {
        &__icon {
          background: #eb4e6d;
        }
        &__text {
          color: #848d9c;
          font-weight: 500;
          font-size: 1.2em;
        }
      }

      &__does-not-exist {
        font-size: 1.25em;
      }
    }
  }
}
</style>
